import America from "../../America";
import {
  AMERICACHANGETRIP,
  AMERICAADDADULT,
  AMERICAMINUSADULT,
  AMERICAADDCHILDREN,
  AMERICAMINUSCHILDREN,
  AMERICAPICKDATE,
  AMERICAADDTOCART,
  AMERICAREMOVEFROMCART,
  AMERICAAIRPORTPICKUP,
  AMERICADIFFERENTHOTEL,
  AMERICAMORETRIPS,
  AMERICAREMOVEALL
} from "../Actions/AmericaTypes";

export default function(state = America, action) {
  switch (action.type) {
    case AMERICACHANGETRIP:
      const changeTripId = state.find(item => item.id === action.payload);
      const changeTripIndex = state.indexOf(changeTripId);
      if (action.data === "day") {
        state[changeTripIndex].tripPriceAdult =
          state[changeTripIndex].dailyPriceAdult;
        state[changeTripIndex].tripPriceChildren =
          state[changeTripIndex].dailyPriceChildren;
      } else if (action.data === "week") {
        state[changeTripIndex].tripPriceAdult =
          state[changeTripIndex].weekPriceAdult;
        state[changeTripIndex].tripPriceChildren =
          state[changeTripIndex].weekPriceChildren;
      } else if (action.data === "month") {
        state[changeTripIndex].tripPriceAdult =
          state[changeTripIndex].monthPriceAdult;
        state[changeTripIndex].tripPriceChildren =
          state[changeTripIndex].monthPriceChildren;
      } else {
        state[changeTripIndex].tripPriceAdult = 0;
        state[changeTripIndex].tripPriceChildren = 0;
      }
      state[changeTripIndex].choosenTrip = action.data;
      state[changeTripIndex].total =
        parseFloat(state[changeTripIndex].adultCount *
          state[changeTripIndex].tripPriceAdult +
        state[changeTripIndex].childrenCount *
          state[changeTripIndex].tripPriceChildren).toFixed(2);
      return [...state];
    case AMERICAADDADULT:
      const addAdultId = state.find(item => item.id === action.payload);
      const addAdultIndex = state.indexOf(addAdultId);
      state[addAdultIndex].adultCount += 1;
      state[addAdultIndex].totalTravelers += 1;
      state[addAdultIndex].total =
      parseFloat(state[addAdultIndex].adultCount * state[addAdultIndex].tripPriceAdult +
        state[addAdultIndex].childrenCount *
          state[addAdultIndex].tripPriceChildren).toFixed(2);
      return [...state];
    case AMERICAMINUSADULT:
      const minusAdultId = state.find(item => item.id === action.payload);
      const minusAdultIndex = state.indexOf(minusAdultId);
      state[minusAdultIndex].adultCount -= 1;
      state[minusAdultIndex].totalTravelers -= 1;
      state[minusAdultIndex].total =
      parseFloat(state[minusAdultIndex].adultCount *
          state[minusAdultIndex].tripPriceAdult +
        state[minusAdultIndex].childrenCount *
          state[minusAdultIndex].tripPriceChildren).toFixed(2);
      return [...state];
    case AMERICAADDCHILDREN:
      const addChildrenId = state.find(item => item.id === action.payload);
      const addChildrenIndex = state.indexOf(addChildrenId);
      state[addChildrenIndex].childrenCount += 1;
      state[addChildrenIndex].totalTravelers += 1;
      state[addChildrenIndex].total =
        parseFloat(state[addChildrenIndex].adultCount *
          state[addChildrenIndex].tripPriceAdult +
        state[addChildrenIndex].childrenCount *
          state[addChildrenIndex].tripPriceChildren).toFixed(2);
      return [...state];
    case AMERICAMINUSCHILDREN:
      const minusChildrenId = state.find(item => item.id === action.payload);
      const minusChildrenIndex = state.indexOf(minusChildrenId);
      state[minusChildrenIndex].childrenCount -= 1;
      state[minusChildrenIndex].totalTravelers -= 1;
      state[minusChildrenIndex].total =
        parseFloat(state[minusChildrenIndex].adultCount *
          state[minusChildrenIndex].tripPriceAdult +
        state[minusChildrenIndex].childrenCount *
          state[minusChildrenIndex].tripPriceChildren).toFixed(2);
      return [...state];
    case AMERICAPICKDATE:
      const pickDateId = state.find(item => item.id === action.payload);
      const pickDateIndex = state.indexOf(pickDateId);
      state[pickDateIndex].dateOption = action.data
      if (state[pickDateIndex].choosenTrip === 'day') {
        if (action.data === 'date1') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].dailyTripDate1
        } else if (action.data === 'date2') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].dailyTripDate2
        } else {
          state[pickDateIndex].choosenDate = state[pickDateIndex].dailyTripDate3
        }
      } else if (state[pickDateIndex].choosenTrip === 'week') {
        if (action.data === 'date1') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].weekTripDate1
        } else if (action.data === 'date2') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].weekTripDate2
        } else {
          state[pickDateIndex].choosenDate = state[pickDateIndex].weekTripDate3
        }
      } else {
        if (action.data === 'date1') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].monthTripDate1
        } else if (action.data === 'date2') {
          state[pickDateIndex].choosenDate = state[pickDateIndex].monthTripDate2
        } else {
          state[pickDateIndex].choosenDate = state[pickDateIndex].monthTripDate3
        }
      }
      return [...state];
      case AMERICAADDTOCART:
      const addCartId = state.find(item => item.id === action.payload);
      const addCartIndex = state.indexOf(addCartId);
      state[addCartIndex].inCart = true;
      return [...state];
      case AMERICAREMOVEFROMCART:
      const removeCartId = state.find(item => item.id === action.payload);
      const removeCartIndex = state.indexOf(removeCartId);
      state[removeCartIndex].inCart = false;
      return [...state];
      case AMERICAAIRPORTPICKUP:
      const airportPickUpId = state.find(item => item.id === action.payload);
      const airportPickUpIndex = state.indexOf(airportPickUpId);
      state[airportPickUpIndex].choosenPickUp = action.data
      state[airportPickUpIndex].totalWithOptions =
        +state[airportPickUpIndex].total +
        +action.data +
        +state[airportPickUpIndex].choosenHotel +
        +state[airportPickUpIndex].choosenTripOption;

      return [...state]
      case AMERICADIFFERENTHOTEL:
        const differentHotelId = state.find(item => item.id === action.payload);
        const differentHotelIndex = state.indexOf(differentHotelId);
        state[differentHotelIndex].choosenHotel = action.data
        state[differentHotelIndex].totalWithOptions =
        +state[differentHotelIndex].total +
        +action.data +
        +state[differentHotelIndex].choosenPickUp +
        +state[differentHotelIndex].choosenTripOption;
        return [...state]
      case AMERICAMORETRIPS:
        const moreTripsID = state.find(item => item.id === action.payload)
        const moreTripsIndex = state.indexOf(moreTripsID)
        state[moreTripsIndex].choosenTripOption = action.data
         state[moreTripsIndex].totalWithOptions =
        +state[moreTripsIndex].total +
        +action.data +
        +state[moreTripsIndex].choosenHotel +
        +state[moreTripsIndex].choosenPickUp;
        return [...state]
        case AMERICAREMOVEALL:
        state.map(item => item.inCart = false)
        return [...state]
    default:
      return state;
  }
}
